var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.8435 83.531H18.5625C17.742 83.531 16.9551 83.2051 16.3749 82.6249C15.7947 82.0447 15.4688 81.2578 15.4688 80.4373V63.1562C15.4687 62.75 15.5488 62.3477 15.7042 61.9723C15.8597 61.597 16.0876 61.2559 16.3749 60.9686L62.7811 14.5624C63.3613 13.9822 64.1482 13.6562 64.9688 13.6562C65.7893 13.6562 66.5762 13.9822 67.1564 14.5624L84.4374 31.8434C85.0176 32.4236 85.3435 33.2105 85.3435 34.031C85.3435 34.8515 85.0176 35.6384 84.4374 36.2186L38.0311 82.6249C37.7439 82.9122 37.4028 83.14 37.0275 83.2955C36.6521 83.451 36.2498 83.531 35.8435 83.531Z",
    stroke: "#123051",
    strokeWidth: 8.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5938 24.75L74.25 46.4062",
    stroke: "#123051",
    strokeWidth: 8.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.927 83.3302L15.6652 62.0684",
    stroke: "#123051",
    strokeWidth: 8.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/Pencil.6f1f76cc10e1d3fe970dde87dd644266.svg";
export { ForwardRef as ReactComponent };